import { Component, Inject, OnInit } from '@angular/core';
import { CustomersComponent } from '../customers/customers.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CustomerService } from '../_ecomservices/customer.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-customer-panel',
  templateUrl: './customer-panel.component.html',
  styleUrls: ['./customer-panel.component.css']
})
export class CustomerPanelComponent implements OnInit {

  customerId: number = 0;
  customerData: any = null;
  constructor(private dialogRef: MatDialogRef<CustomersComponent>, 
    private notificationService: NotificationService,
    public datePipe: DatePipe,
    private customerService: CustomerService,
    @Inject(MAT_DIALOG_DATA) data:any ) { 
    console.log(data);
    this.customerId = data.customerId;
  }

  ngOnInit() {
    this.onLoadCustomerData();
  }

  onLoadCustomerData() {
    this.customerService.getCustomerById(this.customerId).subscribe((data: any) =>{
      console.log(data);
      if(data.status){
        this.customerData = data.customerData;
      }
      else{
        this.notificationService.error(data.message);
      }
    });
    console.log("Loading customer data...");
  }

  onClose() {
    this.dialogRef.close();
  }


}
